// dysonDistributor.js
var DysonDistributor = pc.createScript('dysonDistributor');

DysonDistributor.attributes.add('distributionObjects',{type:'entity', title:'distributionObjects'});
DysonDistributor.attributes.add('maxObjs', {type:'number', default:1200, title:'max objects'});
DysonDistributor.attributes.add('objectArray', {type:'entity', array:true, title:'filled automatically'});

// initialize code called once per entity
DysonDistributor.prototype.initialize = function() {
    this.app.on('systemGenerator:reset', this.reset, this);    
    
    // loop laeuft gleichzeitig mit dysongen - objekte fehlen dort im array
    
    for(var i = 0; i < this.maxObjs; i++){
        var cln = this.distributionObjects.clone();
        this.entity.addChild(cln);
        this.objectArray.push(cln);
    }
    
    
    
};

DysonDistributor.prototype.reset = function(){
    for(var j = 0; j < this.maxObjs; j++){
        this.objectArray[j].children[0].enabled = false;
        this.objectArray[j].children[1].enabled = false;
        this.objectArray[j].children[2].enabled = false;
    }
};

// swap method called for script hot-reloading
// inherit your script state here
// DysonDistributor.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

